<mat-icon [cdkCopyToClipboard]="valueToCopy" class="copy-icon">content_copy</mat-icon>
{{valueToCopy}}
